var LoaderLabelPositions = /*#__PURE__*/ function(LoaderLabelPositions) {
    LoaderLabelPositions["Bottom"] = "bottom";
    LoaderLabelPositions["Right"] = "right";
    return LoaderLabelPositions;
}({});
/**
 * Pass these English strings in to a translation service
 * @example bfTranslate(LoaderLabels.Loading)
 */ var LoaderLabels = /*#__PURE__*/ function(LoaderLabels) {
    LoaderLabels["Loading"] = "Loading";
    LoaderLabels["Saving"] = "Saving";
    return LoaderLabels;
}({});
var LoaderLooks = /*#__PURE__*/ function(LoaderLooks) {
    LoaderLooks["Black"] = "black";
    LoaderLooks["Gray"] = "gray";
    LoaderLooks["Primary"] = "primary";
    LoaderLooks["Warning"] = "warning";
    LoaderLooks["White"] = "white";
    return LoaderLooks;
}({});
var LoaderSizes = /*#__PURE__*/ function(LoaderSizes) {
    LoaderSizes["Large"] = "large";
    LoaderSizes["Medium"] = "medium";
    LoaderSizes["Small"] = "small";
    return LoaderSizes;
}({});
var ShimmerLoaderLooks = /*#__PURE__*/ function(ShimmerLoaderLooks) {
    ShimmerLoaderLooks["Default"] = "default";
    return ShimmerLoaderLooks;
}({});

export { LoaderLabelPositions, LoaderLabels, LoaderLooks, LoaderSizes, ShimmerLoaderLooks };
//# sourceMappingURL=loader.js.map
